export const CSentryKeys = {
    DATA: 'data',
    ERROR: 'error',
    HEADERS: 'headers',
} as const;